module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "meeting-room-selected.ca0016ad.svg";